var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Cross } from '../icon';
import { Button } from '../button';
import { closeButtonStyle } from './styles';
function CloseButton(_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, restProps = __rest(_a, ["inverted"]);
    return (_jsx(Button, __assign({ variant: "plain", size: "small", icon: _jsx(Cross, { size: "xsmall" }), "aria-label": "Close notification", inverted: inverted, css: closeButtonStyle({ inverted: inverted }) }, restProps)));
}
export default CloseButton;
